// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aeeE","comment":"styles_comment__Hf-Fs"};